import { Snackbar } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekSnackbar = styled(Snackbar)(({ theme }) => ({}));

export { PeekSnackbar, PeekSnackbar as default };
